import * as PIXI from "pixi.js";
import Panel from "../../../entities/Panel/Panel";
import Timer from "../../../../../../../src/entities/Timer/Timer";
import { EnumEventBus, eventBus } from "../../EventBus";
import TestButtonFactory from "./TestButtonFactory";
import TestQuestionManager from "../../TestQuestionManager/TestQuestionManager";
import QuestionNavigatorManager from "./QuestionNavigatorManager/QuestionNavigatorManager";
import SwitcherButton from "../../../../../../../src/entities/UI/SwitcherButton/SwitcherButton";
import FlipAnimation from "../../../../../../../src/animation/FlipAnimation";
import { QuestionMode, QuestionType } from "../../../types/Enum";
import { TIMER_COORD } from "../../../types/Config";
import PointAnswerCon from "../PointAnswerCon/PointAnswerCon";
import ResultsCon from "../../../entities/ResultsCon/ResultsCon";
import setQuestionTypes from "./helpers/setQuestionTypes";


export default class TestButtonManager extends PIXI.Container {
  private Panel = Panel.getInstance();
  private TestQuestionManager = TestQuestionManager.getInstance();
  private Timer = new Timer(this, TIMER_COORD, 60 * 40);
  private AnswerCon = this.addChild(new PointAnswerCon());
  private ResultsCon = new ResultsCon()
  private NextQuestion: SwitcherButton = this.addChild(TestButtonFactory.genGenNextQuestionButton());
  private ShowResult: SwitcherButton = this.addChild(TestButtonFactory.genShowResults());
  private startAnswer: SwitcherButton = this.addChild(TestButtonFactory.genStartAnswerButton());
  private saveAnswer: SwitcherButton = this.addChild(TestButtonFactory.genSaveAnswerButton());
  private goToPractise: SwitcherButton = this.addChild(TestButtonFactory.genGoToPractiseButton())
  private tryAgain: SwitcherButton = this.addChild(TestButtonFactory.genTryAgainButton());
  private gotoPractiseMode: SwitcherButton = this.addChild(TestButtonFactory.genGoToTestModeButton());

  constructor() {
    super();
    this.addChild(new QuestionNavigatorManager());
    this.init();
    this.addToPanel();
    eventBus.on(EnumEventBus.setQuestMode, (m: QuestionMode) => this.handleTestMode(m))
    eventBus.on(EnumEventBus.startTest, () => this.Timer.start());
    eventBus.on(EnumEventBus.setQuestMode, () => this.handleSetQuestionMode());
    eventBus.on(EnumEventBus.newQuestion, () => this.flipButtons(false));
    eventBus.on(EnumEventBus.saveAnswer, () => this.handleSaveAnswer());
    eventBus.on(EnumEventBus.showResults, () => this.flipButtons(true));
    eventBus.on(EnumEventBus.startAnswer, (v: boolean) => this.AnswerCon.setButtons(!v));
    eventBus.on(EnumEventBus.questionType, (t: QuestionType) => this.setQuestionAnswer(t));
    eventBus.on(EnumEventBus.showResults, () => this.AnswerCon.visible = false);
    setQuestionTypes(0);
  }
  private addToPanel = () => this.Panel.addChild(this);
  private handleTestMode = (m: QuestionMode) => m == QuestionMode.test && this.init()
  private handleSaveAnswer() {
    this.flipButtons(true);
    this.AnswerCon.setButtons(true)
  }
  private handleSetQuestionMode() {
    this.Timer.reset();
    this.AnswerCon.visible = false;
    this.flipButtons(false)
  }
  private init() {
    this.AnswerCon.visible = false;
    this.NextQuestion.visible = false;
    this.ShowResult.visible = false;
    this.goToPractise.visible = false;
    this.tryAgain.visible = false;
    this.saveAnswer.visible = true;
    this.startAnswer.visible = true;
  }
  setQuestionAnswer(t: QuestionType) {
    if (t == QuestionType.TYPE1) {
      return this.AnswerCon.visible = false;
    }
    this.AnswerCon.visible = true;
    this.AnswerCon.reset();
  }
  async flipButtons(v: boolean) {
    await this.flip(1, 0);
    const questionCount = this.TestQuestionManager.getAnswersLength();
    setQuestionTypes(questionCount);
    const isLast = this.TestQuestionManager.getIsCompleted();
    const showResultVis = this.ShowResult.visible;
    this.NextQuestion.visible = !isLast && v;
    this.ShowResult.visible = isLast && v;
    this.startAnswer.visible = !v;
    this.saveAnswer.visible = !v;
    if (isLast && v && showResultVis) {
      this.ShowResult.visible = false;
      this.goToPractise.visible = true;
      this.tryAgain.visible = true
    }
    await this.flip(0, 1);
  }
  async flip(startVal: number, targetVal: number): Promise<void> {
    const setPanelScale = (v: number) => {
      this.NextQuestion.scale.set(1, v);
      this.ShowResult.scale.set(1, v);
      this.startAnswer.scale.set(1, v);
      this.saveAnswer.scale.set(1, v);
      this.goToPractise.scale.set(1, v);
      this.tryAgain.scale.set(1, v)
    };
    return new Promise(resolve => { new FlipAnimation({ startVal, targetVal, duration: 200 }, setPanelScale, resolve) });
  }
}
